Px.Editor.MobileInstagramGalleryPanel = class MobileInstagramGalleryPanel extends Px.Util.mixin(
  Px.Editor.InstagramGalleryPanel,
  Px.Editor.MobileGalleryPanelMixin
) {
  get css_class() {
    return 'px-instagram-gallery-panel';
  }
};
